var $a9c1da319e5254cb$exports = {};
$a9c1da319e5254cb$exports = {
    "loading": `A carregar...`,
    "loadingMore": `A carregar mais...`
};


export {$a9c1da319e5254cb$exports as default};
//# sourceMappingURL=pt-PT.module.js.map
